var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "Tabs",
        [
          _c(
            "Tab",
            { attrs: { name: "Telco", selected: "true" } },
            [
              _c("TelcoFormGeneral", {
                attrs: { modoVer: true, telcoid_crear: _vm.telcoid_crear }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Planes Telco" } },
            [
              _c("TelcoFormPlanes", {
                attrs: { modoVer: true, telcoid_crear: _vm.telcoid_crear }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Apn" } },
            [
              _c("TelcoFormApn", {
                attrs: { modoVer: true, telcoid_crear: _vm.telcoid_crear }
              })
            ],
            1
          ),
          _c(
            "Tab",
            { attrs: { name: "Stock Crítico" } },
            [
              _c("TelcoFormStock", {
                attrs: { modoVer: true, telcoid_crear: _vm.telcoid_crear }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }